import NavigationBar from "../../navigation/nav-bar/navigationBar";
import NoImageSectionCard from "../../general/noImageSectionCard";
import StoriesHeroSection from "../storiesHeroSection";
import RightTopArrow from "../../../assets/figures/rightTopArrow";
import HorizontalSectionCard from "../../general/horizontalSectionCard";
import Button from "../../general/ui-blocks/elements/button";
import FooterComponent from "../../navigation/footer/footerComponent";
import Accordion from "../../general/ui-blocks/elements/accordion";
import SecondaryParentPage from "./secondaryParentPage";
import CardView from "./cardView";
import ProblemsViewComponent from "./problemsViewComponent";
import ProblemsViewComponen2 from "./problemsViewComponent2";
import ParentHeroSection from "./parentHeroSection";


function ParentCTASection() {
    const cards = [
        {
            label: "Start here",
            title: "Apply Free",
            desc: "The application takes 30 minutes and costs nothing. Cohorts are small. Spots close when they fill.",
            href: "/apply",
            primary: true,
        },
        {
            label: "14 days",
            title: "2027 Startup Sprint",
            desc: "January 2027. 5–10 hrs/week. A live product, a portfolio piece, and a letter of rec.",
            href: "/admissions/2027-startup-sprint",
            primary: false,
        },
        {
            label: "28 days",
            title: "Founder Track",
            desc: "February 2027. 8–12 hrs/week. Full build cycle, deeper iteration, and a founder mentor.",
            href: "/admissions/founder-track",
            primary: false,
        },
        {
            label: "Overview",
            title: "Admissions",
            desc: "Compare programs, see requirements, understand the process, and find the right fit for your student.",
            href: "/admissions",
            primary: false,
        },
    ];

    return (
        <section className="py-20 px-4" style={{ background: "#0f0c09" }}>
            <div className="max-w-5xl mx-auto">
                <div className="text-center mb-12">
                    <p className="text-xs font-semibold tracking-widest uppercase mb-3" style={{ color: "#b07d4a", letterSpacing: "0.14em" }}>
                        Next Steps
                    </p>
                    <h2 className="text-3xl md:text-4xl font-bold mb-3" style={{ color: "#faf8f5" }}>
                        Ready to give your child the edge?
                    </h2>
                    <p className="text-base max-w-xl mx-auto" style={{ color: "rgba(250,248,245,0.45)" }}>
                        Choose where you want to start. The application is free and takes 30 minutes.
                    </p>
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-2 lg:gap-4">
                    {cards.map(({ label, title, desc, href, primary }) => (
                        <a
                            key={href}
                            href={href}
                            className="group flex flex-col rounded-2xl p-4 md:p-6 text-decoration-none transition-all duration-200"
                            style={{
                                background: primary ? "#b07d4a" : "rgba(250,248,245,0.05)",
                                border: primary ? "none" : "1px solid rgba(250,248,245,0.1)",
                            }}
                            onMouseEnter={e => {
                                e.currentTarget.style.background = primary ? "#96683b" : "rgba(250,248,245,0.09)";
                            }}
                            onMouseLeave={e => {
                                e.currentTarget.style.background = primary ? "#b07d4a" : "rgba(250,248,245,0.05)";
                            }}
                        >
                            <span className="text-xs font-semibold tracking-widest uppercase mb-3"
                                style={{ color: primary ? "rgba(255,255,255,0.7)" : "#b07d4a", letterSpacing: "0.12em" }}>
                                {label}
                            </span>
                            <h3 className="text-lg font-bold mb-2" style={{ color: primary ? "#fff" : "#faf8f5" }}>
                                {title}
                            </h3>
                            <p className="text-sm leading-relaxed flex-1" style={{ color: primary ? "rgba(255,255,255,0.75)" : "rgba(250,248,245,0.45)" }}>
                                {desc}
                            </p>
                            <span className="mt-4 text-sm font-semibold" style={{ color: primary ? "#fff" : "#b07d4a" }}>
                                {primary ? "Apply Now →" : "Learn More →"}
                            </span>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default function MainParentPageComponent() {

    return (
        <div>
            <NavigationBar transparent />

            <ParentHeroSection title="Parents Need to Know" titleAdvanced={
                <span><RightTopArrow/> Parents <span className="brand-color">Need to Know</span></span>
            } blurb={
                <div>
                    <p>
                        Give your child an unfair advantage. A good education is no longer enough on its own. Admissions committees and
                        first employers want proof that the <i>new hire</i> can build something, lead a team,
                        and deliver under pressure. This is how your child gets that proof.
                    </p>
                </div>}
            />

            <ProblemsViewComponent />
            <ProblemsViewComponen2 />

            <SecondaryParentPage />

            <NoImageSectionCard title={<strong>What you must know.</strong>} blurb={<div className="space-y-4">

                <div>
                    The students who stand out in college applications and early hiring are not just
                    the ones with the best grades. They are the ones who can point to something real
                    they built: a live product, a role they owned, a problem they solved with a team
                    under a deadline.
                </div>

                <div>
                    Extern Academy gives your child exactly that. In 14, 28, or 48 days, they join a small
                    founding team, take on a specific role, and ship a real consumer product guided by
                    a startup founder who has raised capital and scaled a product to real users. They
                    walk away with a live product, a certificate, and a letter of recommendation that
                    carries dense weight.
                </div>

            </div>} />


            {/* FAQs */}
            <div className="py-8">
                <NoImageSectionCard
                    title={<h2 className="mb-5 text-center text-7xl"><strong>Essential
                        Questions</strong></h2>} shouldRemovePatternWrap={true}/>

                <Accordion title="What level of experience does my child need?" blurb={<div>
                    None. Students are placed in a role that fits their strengths: Product, Engineering, Design, or Marketing. No prior coding or business experience is required. What matters is that they show up, take their role seriously, and contribute to the team.
                </div>}/>

                <Accordion title="How much time does this take each week?" blurb={<div>
                    The 2027 Startup Sprint runs about 2 hours per day over 14 days. The Founder Track runs about 2–3 hours per day over 28 days. The Residency runs about 3–4 hours per day over 48 days. Meeting times are designed to fit around school, sports, and existing commitments, but the work is real and the deadlines are firm.
                </div>}/>

                <Accordion title="Who is supervising my child?" blurb={<div>
                    Every team is guided by a vetted Startup Trainer: a founder who has raised over $1 million in funding and scaled a real product to more than 100,000 users. They run two structured standups per week and stay available on Slack throughout the program.
                </div>}/>

                <Accordion title="What does my child walk away with?" blurb={<div>
                    A live consumer product that stays online for a complete year. A letter of recommendation from their Startup Trainer, a real founder, not a teacher. And a story they can tell in college interviews, on resumes, and in any room where it matters.
                    Three things: a live consumer product that stays online for a complete year — Guaranteed by Extern Academy — a letter of recommendation voucher from their Startup Trainer, redeemable any time an application calls for one, and a story externs can tell in college interviews, on résumés, and in any room where it matters.
                </div>}/>

                <Accordion title="What happens if my child falls behind?" blurb={<div>
                    Teams support each other throughout the program, and the Startup Trainer is available between standups via Slack. The structure is designed to keep everyone moving. If a student is genuinely struggling, we address it directly. No one is left to figure it out alone.
                </div>}/>

            </div>

            <ParentCTASection />

            <FooterComponent />
        </div>
    )
}